import { apiSlice } from "../app/api/apiSlice";

export const discountsApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getUserDiscounts: builder.query({
            query: ({user_id}) => `/user/discounts/${user_id}`,
            transformResponse: responseData => {
                return responseData;
            },
            providesTags: ['Discounts']
        }),
        createUserDiscount: builder.mutation({
            query: (input) => ({
                url: `user/create-discount`,
                method: 'POST',
                body: { ...input }
            }),
            invalidatesTags: ['Discounts']
        }),
        editUserDiscount: builder.mutation({
            query: (input) => ({
                url: `user/edit-discount/${input.id}`,
                method: 'PUT',
                body: { ...input }
            }),
            invalidatesTags: ['Discounts']
        }),
        getDiscountById: builder.query({
            query: (id) => `/user/discount/${id}`,
            transformResponse: responseData => {
                return responseData;
            },
            providesTags: ['Discounts']
        }),
        getUserActiveDiscount: builder.query({
            query: (id) => `/user/user-active-discounts/${id}`,
            transformResponse: responseData => {
                return responseData;
            },
            providesTags: ['Discounts']
        }),
        deleteDiscounts: builder.mutation({
            query: (id) => ({
                url: `user/delete-discount/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Discounts']
        }),
    })
})

export const {
    useCreateUserDiscountMutation,
    useEditUserDiscountMutation,
    useGetUserDiscountsQuery,
    useGetDiscountByIdQuery,
    useGetUserActiveDiscountQuery,
    useDeleteDiscountsMutation,
} = discountsApiSlice

